// removed by extract-text-webpack-plugin
module.exports = {"Link":"RWYZaOgZp2I6NlF5BfJ7b","Active":"_3BwucYsSIyKOQ6fNQiGeYg","IconLeft":"_3SKBvOPtgyMwULcmMLqiRW","IconRight":"Xdi37Z_hRcXNZgzNGZwit","Submenu":"_1y99wqNeYzzF_ig3wPQ6fX","FullSubmenu":"_3tiSAIfyh7MFdF5o7zI779"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/Dropdown/styles.module.css
// module id = 587
// module chunks = 0